"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectTransformer = void 0;
class ObjectTransformer {
    static formatKeys(obj, formatter) {
        const formattedObj = {};
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                const newKey = formatter(key);
                const value = obj[key];
                formattedObj[newKey] =
                    value && typeof value === 'object' && !Array.isArray(value) ? ObjectTransformer.formatKeys(value, formatter) : value;
            }
        }
        return formattedObj;
    }
    static toSnakeCaseFormatter(key) {
        return key.replace(/([A-Z])/g, '_$1').toLowerCase();
    }
    static toCamelCaseFormatter(key) {
        return key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
    }
    static toKebabCaseFormatter(key) {
        return key.replace(/([A-Z])/g, '-$1').toLowerCase();
    }
    static toPascalCaseFormatter(key) {
        return key.replace(/(^\w|_\w)/g, (_, letter) => letter.toUpperCase().replace('_', ''));
    }
    static toUpperCaseFormatter(key) {
        return key.toUpperCase();
    }
    static toLowerCaseFormatter(key) {
        return key.toLowerCase();
    }
}
exports.ObjectTransformer = ObjectTransformer;
ObjectTransformer.toSnakeCase = obj => {
    return ObjectTransformer.formatKeys(obj, ObjectTransformer.toSnakeCaseFormatter);
};
ObjectTransformer.toCamelCase = obj => {
    return ObjectTransformer.formatKeys(obj, ObjectTransformer.toCamelCaseFormatter);
};
ObjectTransformer.toKebabCase = obj => {
    return ObjectTransformer.formatKeys(obj, ObjectTransformer.toKebabCaseFormatter);
};
ObjectTransformer.toPascalCase = obj => {
    return ObjectTransformer.formatKeys(obj, ObjectTransformer.toPascalCaseFormatter);
};
ObjectTransformer.toUpperCase = obj => {
    return ObjectTransformer.formatKeys(obj, ObjectTransformer.toUpperCaseFormatter);
};
ObjectTransformer.toLowerCase = obj => {
    return ObjectTransformer.formatKeys(obj, ObjectTransformer.toLowerCaseFormatter);
};
//# sourceMappingURL=ObjectTransformer.js.map